import { PickPoint } from '@pnext/three-loader';
import { atom } from 'jotai';

export interface PickedPoint extends PickPoint {
  screenX: number;
  screenY: number;
  cameraAngle: number;
  /** Per-point scalar attributes copied off the picked Potree node (e.g.
   *  Deviation as written by deviation.py). Keyed by the geometry attribute
   *  name; values are numbers for itemSize-1 attribs, arrays otherwise. */
  attributes?: Record<string, number | number[]>;
  /** Layer id of the picked point cloud, if available (set when the hit was
   *  on a Potree pointcloud whose userData carries a layerId). */
  pointCloudLayerId?: string;
}

export const pickedPointAtom = atom<PickedPoint | null>(null);
